module.exports = {
      id: "gemini-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#gemini",
      toString: function () {
        return this.url;
      }
    }